import makeStrictKeysObject from "@/util/strict-keys-object.mjs";

const tftRefs = makeStrictKeysObject({
  inGamePlacement: null as HTMLDivElement | null,
  getTraitIcon: null,
  translatedLevelingMethods: null,
});

export default tftRefs;
